import EventBus from '/@/modules/core/app/helpers/EventBus';
import ModalService from '/@/modules/core/ui/services/ModalService';
import { ModalBrowserBackButtonEvent } from '/@/modules/core/ui/ui.constants';

export const ModalBrowserBackButtonMixin = {
  methods: {
    onModalCanClose() {
      // to be implemented by child step component
      if (this.onPopState) {
        return this.onPopState();
      }

      if (ModalService.isModalShowing) {
        return ModalService.close();
      }
    }
  },
  mounted() {
    EventBus.listen(ModalBrowserBackButtonEvent.ON_BACK_BUTTON_PRESSED, this.onModalCanClose);
  },
  beforeUnmount() {
    EventBus.destroy(ModalBrowserBackButtonEvent.ON_BACK_BUTTON_PRESSED, this.onModalCanClose);
  }
};
